import React from 'react';
import {Slider, withStyles} from '@material-ui/core';
import { P3Bold } from './Text';
import colours from './Colours';

const MediaSlider = (props) => {

    const getLabel = () => {
        let x = props.value;

        if (x == 0 || (x >= 0 && x < 20)) {
            return "Negative"
        } else if (x && x >= 20 && x < 40) {
            return "Somewhat Negative"
        } else if (x && x >= 40 && x < 60) {
            return "Neutral"
        } else if (x && x >= 60 && x < 80) {
            return "Somewhat Positive"
        } else if (x && x >= 80) {
            return "Positive"
        } else {
            return "Unrated"
        } 
    }

    const getColor = () => {
        let x = props.value;

        if (x == 0 || (x >= 0 && x < 20)) {
            return colours.accent.error_red;
        } else if (x && x >= 20 && x < 40) {
            return "#F7916A";
        } else if (x && x >= 40 && x < 60) {
            return "#FECE7F";
        } else if (x && x >= 60 && x < 80) {
            return "#96C48B";
        } else if (x && x >= 80) {
            return colours.accent.validate_green;
        } else {
            return colours.primary.grey03;
        } 
    }

    const CustomSlider = withStyles({
        root: {
            color: getColor(),
            height: 3,
            padding: "13px 0",
            cursor: props.readOnly ? 'initial' : 'pointer'
        },
        disabled: {
            color: getColor(),
            height: 3,
            padding: "13px 0",
            cursor: props.readOnly ? 'initial' : 'pointer'
        },
        track: {
            height: 4,
            borderRadius: 2,
        },
        thumb: {
            height: 10,
            width: 10,
            backgroundColor: "#fff",
            border: `1px solid ${getColor()}`,
            marginTop: -3,
            marginLeft: 0,
            boxShadow: "#ebebeb 0 2px 2px",
            "&:focus, &:hover, &$active": {
                boxShadow: "#ccc 0 2px 3px 1px",
            },
            color: "#fff",
        },
    })(Slider);


    return (
        <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
            <CustomSlider
                marks
                step={20}
                min={0}
                max={100}
                value={props.value}
                valueLabelDisplay="off"
                disabled={props.disabled}
                readOnly={props.readOnly}
                onChange={props.onChange}
            />
            <div style={{display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                <P3Bold>{getLabel()}</P3Bold>
            </div>
        </div>
    )
}

export default MediaSlider;